//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('businessS', {
//        templateUrl: 'views/components/views/businessS/businessS.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['stateService', 'businessSService', function (stateService, businessSService) {
//			const vm = this;

//            vm.model = {
//                itemsListBusinessViews: []
//            };

//            async function loadBusinesses() {
//                vm.model.itemsListBusinessViews = (await businessSService.listBusinessViews());
//            }

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'business':
//                        go({ business_id: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            vm.$onInit = function () {
//                loadBusinesses();
//            };
//		}]
//	});
//})();
